/** Dados dos KPIs das comissões */
export class Comissao {
    valorPago: number;
    valorComissao: number;
    percComissao: number;

    constructor(props: Partial<Comissao>) {
        Object.assign(this, props);
    }

    /**
     * Cria o objeto através do JSON informado
     *
     * @param json JSON com as propriedades para criar o objeto
     * @returns objet criado
     */
    static fromJSON(json: string): Comissao {
        return new Comissao(JSON.parse(json));
    }
}
